<template>
    <Popup ref="popup" :animation="'fade'" >
        <div class="login-cont t-c" >
            <div class="item close-item" >
                <span class="close" @click.stop="hide" ></span>
            </div>
            <div class="item title" >
                <span class="fs-2-5 fb segoe" >{{ $t("message.guestLogin") }}</span>
            </div>
            <div class="item t-c userid-item" >
                <input type="text" v-model="userID" class="t-l segoe" inputmode="numeric" :placeholder="$t('message.inputUserId')" maxlength="17" @input="onInputChange" />
                <img class="userid-tip btn" :src="_global.assetsRoot + '/button.png'" @click="showUserIDTip" />
            </div>
            <div class="item btn-item" >
                <div class="btn login-btn" @click.stop="guestLogin" >
                    <span class="fs-2-5 fb segoe" >{{ $t("message.login") }}</span>
                </div>
            </div>
        </div>
    </Popup>
</template>

<script>
import Popup from '../Popup.vue'
export default {
    data() {
        return {
            userID: null,
            tip: false,
            customTip: null,
            duration: 3000,
            timer: null
        }
    },
    created() {
        this.userID = this._global.userID;
    },
    computed: {
        tipText() { return this.customTip || this.$t("message.userIDErrorTip")}
    },
    methods: {
        show() { this.$refs.popup.show() },
        hide(e) { e && e.stopPropagation(), this.$refs.popup.hide() },
        onInputChange(e) { this.userID = this.userID.replace(/[^\d]/g, '') },
        guestLogin() {
            this.$emit('onguestlogin', { userID: this.userID })
        },
        showTip(tip) {
            this.$emit("showTip", { text: tip })
        },
        showUserIDTip() {
            this.$emit("showUserIDTip")
        }
    },
    components: { Popup }
}
</script>

<style lang="scss" >
.login-cont {
    width: 76vw;
    margin: 0 auto;
    padding: .5rem 4%;
    background-color: #FFF;
    border-radius: 3px;

    .item {

        input {
            width: 100%;
            height: 5rem;
            border-radius: .6rem;
            text-indent: 1.4rem;
            background-color: #EEE;
        }

        input::placeholder {
            font-family: "SegoeUIBold";
            font-size: 1.4rem;
            font-weight: bold;
            color: #C6C6C6;
        }

        .login-btn {
            width: 60vw;
            height: 5rem;
            line-height: 5rem;
            margin: 0 auto;
            background-color: #4BAFD3;
            border-radius: 3px;
            margin-bottom: 3rem;

            span {
                color: #FFF;
            }
        }
    }

    .userid-item {
        position: relative;

        .userid-tip {
            position: absolute;
            right: 0;
            top: 0;
            height: 100%;
        }
    }

    .title {
        margin-bottom: 4rem;
    }

    .close-item {
        text-align: right;

        .close {
            position: relative;
            display: inline-block;
            width: 3rem;
            height: 3rem;
            transform: rotate(45deg);
            -webkit-transform: rotate(45deg);
            margin-right: -1rem;
        }

        .close::before, .close::after {
            content: "";
            position: absolute;
            width: 2.4rem;
            height: 4px;
            border-radius: 2px;
            background-color: #C6C6C6;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            -webkit-transform: translate(-50%, -50%);
        }

        .close::after {
            transform: translate(-50%, -50%) rotate(90deg);
            -webkit-transform: translate(-50%, -50%) rotate(90deg);
        }
    }

    .btn-item {
        margin-top: 4rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/popup/MobileGuestLogin.vue